export function tokenFor(option, optItem) {
  const optionId =
    option?.menuItemOptionId ??
    option?.tcMenuItemOptionId ??
    option?.option?.menuItemOptionId ??
    option?.option?.tcMenuItemOptionId ??
    0;

  const optionName =
    option?.name ??
    option?.optionName ??
    option?.option?.name ??
    option?.option?.optionName ??
    "";

  const itemId =
    optItem?.menuItemOptionItemId ??
    optItem?.tcMenuItemOptionItemsId ??
    optItem?.optionItemId ??
    0;

  const itemName =
    optItem?.name ??
    optItem?.optionItemName ??
    "";

  const price = Number(optItem?.price ?? 0);

  return JSON.stringify({
    label: optionName ? `${optionName}: ${itemName}` : itemName,
    price,
    optionId: Number(optionId) || 0,
    itemId: Number(itemId) || 0,
  });
}